export function browserCanGoBack(): boolean {
  if (typeof window === "undefined") return false;
  const nav = window.navigation as { canGoBack?: boolean } | undefined;
  if (nav != null && typeof nav.canGoBack === "boolean") {
    return nav.canGoBack;
  }
  return window.history.length > 1;
}
